module.exports = __webpack_public_path__ + "static/img/product_society.b5cf925.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/product_society.png
// module id = /+1L
// module chunks = 0